import { RootState } from 'store';

const UnsavedState = (state: RootState) => state.weeklyPlanner.unsaved;

export const selectAllChanges = (state: RootState) => UnsavedState(state).appointments;
export const selectAllChangesCount = (state: RootState) => Object.values(UnsavedState(state).appointments).length;
